/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Analysis } from './analysis';
import { AnalysisHeader } from './analysisHeader';


export interface AnalysisProcedureResponse { 
    analysisHeader?: Array<AnalysisHeader>;
    analysis?: Array<Analysis>;
}

